// Apora Story Section JS (Shopify assets version)
// Uses GSAP and ScrollTrigger loaded via CDN in the section

(function() {
  var gsapInstance = window.gsap;
  var ScrollTrigger = window.ScrollTrigger || (gsapInstance && gsapInstance.core && gsapInstance.core.globals && gsapInstance.core.globals().ScrollTrigger);
  if (gsapInstance && ScrollTrigger) {
    gsapInstance.registerPlugin(ScrollTrigger);
  }

  var mobileDeviceRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  function isMobileDevice() {
    return window.innerWidth <= 768 || mobileDeviceRegex.test(navigator.userAgent);
  }

  var waterBlobInstance = null;
  var waterBlobScrollProgressTrigger = null;
  var waterBlobPositionTimeline = null;
  var waterBlobPinTrigger = null;

  document.addEventListener('DOMContentLoaded', function() {
    // Wait for images to load before initializing animations
    waitForImages();
  });

  // Simple SplitText replacement: wraps words in span.word
  function splitIntoWordSpans(el) {
    if (!el || el.dataset && el.dataset.split === 'true') return el ? el.querySelectorAll('.word') : [];
    var text = el.textContent || '';
    var words = text.trim().split(/\s+/);
    var html = '';
    for (var i = 0; i < words.length; i++) {
      var word = words[i];
      if (!word) continue;
      html += '<span class="word">' + word.replace(/</g, '&lt;').replace(/>/g, '&gt;') + '</span>' + (i < words.length - 1 ? ' ' : '');
    }
    el.innerHTML = html;
    if (!el.dataset) el.dataset = {};
    el.dataset.split = 'true';
    return el.querySelectorAll('.word');
  }

  function waitForImages() {
    var images = document.querySelectorAll('.section-story img');
    var loadedImages = 0;

    if (images.length === 0) {
      startStoryAnimations();
      return;
    }

    images.forEach(function(img) {
      if (img.complete) {
        loadedImages++;
      } else {
        img.addEventListener('load', function() {
          loadedImages++;
          if (loadedImages === images.length) {
            startStoryAnimations();
          }
        });
      }
    });

    setTimeout(function() {
      if (loadedImages < images.length) {
        startStoryAnimations();
      }
    }, 3000);

    if (loadedImages === images.length) {
      startStoryAnimations();
    }
  }

  function WaterBlobCanvas(canvas) {
    this.canvas = canvas;
    this.ctx = canvas.getContext('2d');
    this.points = [];
    this.time = 0;
    this.pixelRatio = window.devicePixelRatio || 1;
    this.scrollProgress = 0.5;
    this.animationFrame = null;
    this.running = false;
    this.lastTime = performance.now();

    this.animate = this.animate.bind(this);
    this.handleResize = this.handleResize.bind(this);

    this.setupPoints();
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  }

  WaterBlobCanvas.prototype.setupPoints = function() {
    var totalPoints = 18;
    this.points = Array.from({ length: totalPoints }, function(_, index) {
      return {
        angle: (Math.PI * 2 * index) / totalPoints,
        offset: Math.random() * Math.PI * 2
      };
    });
  };

  WaterBlobCanvas.prototype.handleResize = function() {
    var rect = this.canvas.getBoundingClientRect();
    this.pixelRatio = Math.min(2, window.devicePixelRatio || 1);
    this.canvas.width = rect.width * this.pixelRatio;
    this.canvas.height = rect.height * this.pixelRatio;
    this.displayWidth = rect.width;
    this.displayHeight = rect.height;
    this.centerX = this.displayWidth / 2;
    this.centerY = this.displayHeight / 2;

    var minDimension = Math.min(this.displayWidth, this.displayHeight);
    this.baseRadius = minDimension * 0.34;
    this.amplitude = this.baseRadius * 0.28;
    this.highlightRadius = this.baseRadius * 0.6;
  };

  WaterBlobCanvas.prototype.setScrollProgress = function(progress) {
    this.scrollProgress = progress;
  };

  WaterBlobCanvas.prototype.start = function() {
    if (this.running) return;
    this.running = true;
    this.lastTime = performance.now();
    this.animate(this.lastTime);
  };

  WaterBlobCanvas.prototype.stop = function() {
    this.running = false;
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
      this.animationFrame = null;
    }
    window.removeEventListener('resize', this.handleResize);
  };

  WaterBlobCanvas.prototype.animate = function(now) {
    if (!this.running) return;
    var delta = now - this.lastTime;
    this.lastTime = now;
    this.time += delta * 0.001;
    this.draw();
    this.animationFrame = requestAnimationFrame(this.animate);
  };

  WaterBlobCanvas.prototype.draw = function() {
    var ctx = this.ctx;
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    ctx.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);

    var cx = this.centerX;
    var cy = this.centerY + this.displayHeight * 0.04;
    var waveInfluence = (this.scrollProgress - 0.5) * 0.2;
    var radiusBase = this.baseRadius * (1 + waveInfluence);
    var amplitude = this.amplitude * (0.6 + this.scrollProgress * 0.8);

    var points = this.points.map(function(point) {
      var wavePrimary = Math.sin(point.angle * 2.4 + this.time * 0.9 + point.offset);
      var waveSecondary = Math.sin(point.angle * 3.6 + this.time * 1.6 - point.offset * 1.2);
      var displacement = (wavePrimary * 0.7 + waveSecondary * 0.3);
      var radius = radiusBase + displacement * amplitude;
      return {
        x: cx + Math.cos(point.angle) * radius,
        y: cy + Math.sin(point.angle) * radius * 0.92
      };
    }, this);

    if (points.length === 0) return;

    ctx.beginPath();
    ctx.moveTo(points[0].x, points[0].y);
    for (var i = 0; i < points.length; i++) {
      var current = points[i];
      var next = points[(i + 1) % points.length];
      var controlX = (current.x + next.x) / 2;
      var controlY = (current.y + next.y) / 2;
      ctx.quadraticCurveTo(current.x, current.y, controlX, controlY);
    }
    ctx.closePath();

    var gradient = ctx.createRadialGradient(
      cx,
      cy - radiusBase * 0.35,
      radiusBase * 0.15,
      cx,
      cy,
      radiusBase * 1.4
    );
    gradient.addColorStop(0, 'rgba(146, 220, 255, 0.9)');
    gradient.addColorStop(0.45, 'rgba(36, 160, 255, 0.7)');
    gradient.addColorStop(1, 'rgba(6, 42, 92, 0.05)');
    ctx.fillStyle = gradient;
    ctx.fill();

    ctx.globalCompositeOperation = 'lighter';
    ctx.beginPath();
    ctx.ellipse(
      cx - radiusBase * 0.22,
      cy - radiusBase * 0.62,
      this.highlightRadius * 0.45,
      this.highlightRadius * 0.25,
      -0.35,
      0,
      Math.PI * 2
    );
    var highlightGradient = ctx.createRadialGradient(
      cx - radiusBase * 0.22,
      cy - radiusBase * 0.62,
      0,
      cx - radiusBase * 0.22,
      cy - radiusBase * 0.62,
      this.highlightRadius
    );
    highlightGradient.addColorStop(0, 'rgba(255, 255, 255, 0.65)');
    highlightGradient.addColorStop(0.7, 'rgba(188, 226, 255, 0.08)');
    highlightGradient.addColorStop(1, 'rgba(188, 226, 255, 0)');
    ctx.fillStyle = highlightGradient;
    ctx.fill();

    ctx.globalCompositeOperation = 'source-over';
    ctx.beginPath();
    ctx.ellipse(
      cx + radiusBase * 0.28,
      cy + radiusBase * 0.34,
      this.highlightRadius * 0.32,
      this.highlightRadius * 0.52,
      0.28,
      0,
      Math.PI * 2
    );
    var shadowGradient = ctx.createRadialGradient(
      cx + radiusBase * 0.28,
      cy + radiusBase * 0.34,
      0,
      cx + radiusBase * 0.28,
      cy + radiusBase * 0.34,
      this.highlightRadius * 1.1
    );
    shadowGradient.addColorStop(0, 'rgba(4, 62, 122, 0.3)');
    shadowGradient.addColorStop(1, 'rgba(4, 62, 122, 0)');
    ctx.fillStyle = shadowGradient;
    ctx.fill();
  };

  function initWaterBlob() {
    var canvas = document.getElementById('storyWaterBlob');
    if (!canvas) return;

    if (!waterBlobInstance) {
      waterBlobInstance = new WaterBlobCanvas(canvas);
      waterBlobInstance.start();
    }

    configureWaterBlobMotion();

    if (!initWaterBlob.resizeBound) {
      window.addEventListener('resize', configureWaterBlobMotion);
      initWaterBlob.resizeBound = true;
    }
  }

  function startStoryAnimations() {
    initParallaxAnimations();
    initWaterBlob();
  }

  function configureWaterBlobMotion() {
    var canvas = document.getElementById('storyWaterBlob');
    if (!canvas) return;

    var isMobile = isMobileDevice();

    if (isMobile) {
      if (waterBlobScrollProgressTrigger) {
        waterBlobScrollProgressTrigger.kill();
        waterBlobScrollProgressTrigger = null;
      }
      if (waterBlobPositionTimeline) {
        waterBlobPositionTimeline.kill();
        waterBlobPositionTimeline = null;
      }
      if (waterBlobPinTrigger) {
        waterBlobPinTrigger.kill();
        waterBlobPinTrigger = null;
      }
      gsapInstance && gsapInstance.set && gsapInstance.set(canvas, { xPercent: -50, yPercent: -50 });
      if (waterBlobInstance && waterBlobInstance.setScrollProgress) {
        waterBlobInstance.setScrollProgress(0.5);
      }
      return;
    }

    if (gsapInstance && ScrollTrigger) {
      if (!waterBlobScrollProgressTrigger) {
        waterBlobScrollProgressTrigger = ScrollTrigger.create({
          trigger: '.story-points',
          start: 'top bottom',
          end: 'bottom top',
          onUpdate: function(self) { waterBlobInstance && waterBlobInstance.setScrollProgress(self.progress); }
        });
      } else {
        waterBlobScrollProgressTrigger.refresh();
      }

      if (!waterBlobPinTrigger) {
        waterBlobPinTrigger = ScrollTrigger.create({
          trigger: '.story-points',
          start: 'top top',
          end: 'bottom bottom',
          pin: '#storyWaterBlob',
          pinSpacing: false
        });
      } else {
        waterBlobPinTrigger.refresh();
      }

      if (!waterBlobPositionTimeline) {
        gsapInstance.set(canvas, { xPercent: 0, yPercent: 0, force3D: true });
        waterBlobPositionTimeline = gsapInstance.timeline({
          scrollTrigger: {
            trigger: '.story-points',
            start: 'top top',
            end: 'bottom bottom',
            scrub: 1
          }
        });
        waterBlobPositionTimeline.to(canvas, {
          duration: 1,
          ease: 'none',
          keyframes: [
            { xPercent: -35, yPercent: -10 },
            { xPercent: 35, yPercent: 10 },
            { xPercent: -25, yPercent: 5 }
          ]
        });
      } else {
        waterBlobPositionTimeline.scrollTrigger && waterBlobPositionTimeline.scrollTrigger.refresh();
      }
    }
  }

  function initParallaxAnimations() {
    if (!gsapInstance) return;

    var isMobile = isMobileDevice();

    if (isMobile) {
      gsapInstance.set('.story-content', { y: 0, opacity: 1 });
      gsapInstance.set('.story-image', { y: 0, opacity: 1 });
      gsapInstance.set('.story-step-title', { y: 0, opacity: 1 });
    }

    gsapInstance.set('.story-heading', { transformOrigin: 'center center' });
    gsapInstance.fromTo(
      '.story-heading',
      { scale: 0.8, opacity: 1, filter: 'blur(0px)' },
      {
        scale: 1,
        opacity: 0,
        filter: 'blur(30px)',
        ease: 'none',
        scrollTrigger: ScrollTrigger ? {
          trigger: '.story-heading',
          start: 'top top',
          end: '+=80%',
          scrub: 1,
          pin: true,
          pinSpacing: false
        } : undefined
      }
    );

    var storyWrappers = document.querySelectorAll('.story-item-wrapper');

    var introHeading = document.querySelector('.story-intro h2');
    if (introHeading) {
      var introWords = splitIntoWordSpans(introHeading);
      if (introWords && introWords.length) {
        gsapInstance.set(introWords, { y: 30, opacity: 0, filter: 'blur(8px)' });
        gsapInstance.to(introWords, {
          y: 0,
          opacity: 1,
          filter: 'blur(0px)',
          stagger: 0.06,
          ease: 'power2.out',
          scrollTrigger: ScrollTrigger ? {
            trigger: '.story-intro',
            start: 'top 80%',
            toggleActions: 'play none none reverse'
          } : undefined
        });
      }
    }

    if (!isMobile) {
      gsapInstance.set('.story-content', { y: 50, opacity: 0 });
      gsapInstance.set('.story-image', { y: -50, opacity: 0 });
      gsapInstance.set('.story-step-title', { y: 30, opacity: 0 });
      gsapInstance.set('.sc-date', { y: -100, opacity: 0.05 });
    }

    storyWrappers.forEach(function(wrapper) {
      var content = wrapper.querySelector('.story-content');
      var image = wrapper.querySelector('.story-image');
      var title = wrapper.querySelector('.story-step-title');
      var description = wrapper.querySelector('.story-step-description');
      var img = wrapper.querySelector('.story-image video');
      var date = wrapper.querySelector('.sc-date');

      if (!isMobile && content) {
        gsapInstance.to(content, {
          y: 0,
          opacity: 1,
          duration: 1.2,
          ease: 'power2.out',
          scrollTrigger: ScrollTrigger ? {
            trigger: wrapper,
            start: 'top bottom',
            end: 'bottom top',
            toggleActions: 'play none none reverse'
          } : undefined
        });
      }

      if (!isMobile && image) {
        gsapInstance.to(image, {
          y: 0,
          opacity: 1,
          duration: 1.2,
          ease: 'power2.out',
          scrollTrigger: ScrollTrigger ? {
            trigger: wrapper,
            start: 'top bottom',
            end: 'bottom top',
            toggleActions: 'play none none reverse'
          } : undefined
        });
      }

      if (!isMobile && title) {
        gsapInstance.to(title, {
          y: 0,
          opacity: 1,
          duration: 0.8,
          ease: 'power2.out',
          scrollTrigger: ScrollTrigger ? {
            trigger: wrapper,
            start: 'top bottom',
            end: 'bottom top',
            toggleActions: 'play none none reverse'
          } : undefined
        });
      }

      if (!isMobile && date) {
        gsapInstance.to(date, {
          y: 0,
          opacity: 0.05,
          duration: 1.5,
          ease: 'power2.out',
          scrollTrigger: ScrollTrigger ? {
            trigger: wrapper,
            start: 'top bottom',
            end: 'center center',
            toggleActions: 'play none none reverse'
          } : undefined
        });
      }

      if (description) {
        var descWords = splitIntoWordSpans(description);
        if (descWords && descWords.length) {
          gsapInstance.set(descWords, { filter: 'blur(10px)', opacity: 0, y: 20 });
          gsapInstance.to(descWords, {
            filter: 'blur(0px)',
            opacity: 1,
            y: 0,
            ease: 'power2.out',
            stagger: 0.1,
            scrollTrigger: ScrollTrigger ? {
              trigger: wrapper,
              start: 'top 60%',
              toggleActions: 'play none none reverse'
            } : undefined
          });
        }
      }

      if (!isMobile && img) {
        gsapInstance.to(img, {
          yPercent: -50,
          ease: 'none',
          scrollTrigger: ScrollTrigger ? {
            trigger: wrapper,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 1
          } : undefined
        });
      }

      if (!isMobile && content) {
        gsapInstance.to(content, {
          yPercent: -15,
          ease: 'none',
          scrollTrigger: ScrollTrigger ? {
            trigger: wrapper,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 1
          } : undefined
        });
      }
    });

    if (ScrollTrigger) {
      ScrollTrigger.refresh();
    }
  }

  function initStoryLineDraw() {
    if (!gsapInstance) return;
    var lineHolder = document.querySelector('.story-line svg');
    if (!lineHolder) return;
    var path = lineHolder.querySelector('path');
    if (!path) return;
    var length = path.getTotalLength();
    path.style.stroke = 'rgba(255,255,255,0.7)';
    path.style.strokeWidth = '2';
    path.style.fill = 'none';
    path.style.strokeDasharray = String(length);
    path.style.strokeDashoffset = String(length);

    gsapInstance.to(path, {
      strokeDashoffset: 0,
      ease: 'none',
      scrollTrigger: ScrollTrigger ? {
        trigger: '.story-points',
        start: 'top center',
        endTrigger: '.story-line',
        end: 'bottom bottom',
        scrub: 1
      } : undefined
    });
  }

  var __origInit = initParallaxAnimations;
  initParallaxAnimations = function() {
    __origInit();
    initStoryLineDraw();
  };
})();


